// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseSettings_root__VNr7d {
  padding: 15px 40px 90px 40px;
  height: calc(100vh - 188px);
  overflow: auto;
  color: var(--color-font-10);
  max-width: 1125px;
}

.BaseSettings_settlement_portal_title__g3OQR {
  display: flex;
  align-items: center;
}

.BaseSettings_device_icon__1az74 {
  padding-right: 10px;
}

.BaseSettings_arrow_icon__KIQDF {
  padding: 0 20px;
  color: var(--color-theme-silver);
}

.BaseSettings_tabs_container__lrhk\\+ {
  margin-top: 60px;
  border: 1px solid var(--color-theme-bright-gray);
}

.BaseSettings_tabs_content_container__aMQWA {
  padding: 60px 30px 30px 30px;
  border: 1px solid var(--color-theme-bright-gray);
  border-top: none;
}

.BaseSettings_tabs_content_container_images__8cMbo {
  border: 1px solid var(--color-theme-bright-gray);
  border-top: none;
}

.BaseSettings_tab_content_portal_address__D4g7a {
  width: 70%;
}

.BaseSettings_tab_content_legal_contact__EyTmB {
  width: 775px;
}

.BaseSettings_example_input_container__ap\\+r9 {
  display: flex;
  align-items: center;
}

.BaseSettings_example_input_container__ap\\+r9 p {
  padding: 0 10px;
  margin-bottom: 8px;
}

.BaseSettings_input_container__Ahbzb {
  width: 370px !important;
}

.BaseSettings_subdomain_container__-mUoI {
  padding-bottom: 40px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--color-theme-bright-gray);
}

.BaseSettings_label__TPkw9 {
  padding: 0;
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.BaseSettings_label__TPkw9 b {
  font-size: 12px;
  color: var(--color-theme-red);
  padding-left: 5px;
}

.BaseSettings_confirm_btn_container__fGun2 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 30px 0;
}

.BaseSettings_confirm_btn__7z0Bb {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
}

.BaseSettings_description__Aimw7 {
  margin: 0;
  margin-bottom: 25px;
  font-size: 16px !important;
}

.BaseSettings_logo_container__IOAlK {
  width: 50%;
}

.BaseSettings_input_row__cjSDe {
  display: flex;
  justify-content: space-between;
}

/* image upload shared */
.BaseSettings_general_col_images__B05lT {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.BaseSettings_general_image_container__rvHeB {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.BaseSettings_upload_title_container__9-9Gh {
  display: flex;
  flex-direction: row;
}

.BaseSettings_portal_image_preview_container__jdQS5 {
  width: 50%;
}

.BaseSettings_upload_size__mJ2Ci {
  color: var(--color-theme-silver);
  font-weight: bold !important;
  font-size: 12px !important;
}

.BaseSettings_dimension_list__QosR0 {
  padding-left: 10px;
  font-size: 12px !important;
}

.BaseSettings_upload_size__mJ2Ci {
  font-size: 12px !important;
  font-weight: 500;
  margin: 0;
  margin-top: 5px;
}

.BaseSettings_cloud_upload_icon__ZMZDQ {
  color: var(--color-theme-blue);
  cursor: pointer;
  font-size: 120px;
}

.BaseSettings_cloud_upload_icon_container__3p0TS {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
}

.BaseSettings_cloud_upload_icon__ZMZDQ:hover {
  color: var(--color-theme-blue);
}

/* Logo */
.BaseSettings_logo_box__aeKp3 {
  width: 84px;
  height: 84px;
  border-radius: 2px;
  overflow: auto;
  border: 1px dashed var(--color-border-dashed);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.BaseSettings_logo__Qxkmx {
  width: 100%;
  object-fit: cover;
}

/* Favicon */
.BaseSettings_favicon_box__EduQJ {
  border: 1px dashed var(--color-border-dashed);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 84px;
  border-radius: 2px;
  overflow: auto;
  position: relative;
}

.BaseSettings_favicon__f94U1 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.BaseSettings_upload_container__z1\\+vB {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.BaseSettings_upload_label__vRGQl {
  border: 1px solid var(--color-theme-silver);
  border-radius: 15px;
  background-color: var(--color-theme-silver);
  padding: 2px 10px;
  cursor: pointer;
  margin: 10px;
  box-shadow: 1px 1px 1px var(--color-theme-darkgray);
  text-align: center;
}

.BaseSettings_upload_label_disabled__XptrK {
  border: 1px solid var(--color-theme-silver);
  border-radius: 15px;
  background-color: var(--color-theme-silver);
  padding: 2px 10px;
  margin: 10px;
  text-align: center;
}

.BaseSettings_upload_input__OTbaR {
  display: none;
}

.BaseSettings_upload_btn__RLIgX {
  width: 120px;
  height: 28px;
  font-weight: bold !important;
  color: var(--color-theme-10) !important;
  background-color: var(--color-theme-silver) !important;
  margin: 0 10px !important;
}

.BaseSettings_image_label__hjSd7 {
  margin-top: 0px;
  margin-left: 0px;
}

/* delete icon containers */
.BaseSettings_delete_icon_container_logo__eS8-n {
  width: 85px;
  display: flex;
  justify-content: flex-end;
  z-index: 10000;
  position: absolute;
  top: 0;
  left: 0;
}

.BaseSettings_delete_icon_container_favicon__6dvSG {
  width: 84px;
  display: flex;
  justify-content: flex-end;
  z-index: 10000;
  position: absolute;
  top: 0;
  left: 0;
}

.BaseSettings_delete_icon__LvwRG {
  color: var(--color-theme-silver);
  background-color: var(--color-theme-snow);
  cursor: pointer;
  padding: 5px;
}

.BaseSettings_delete_icon__LvwRG:hover {
  color: var(--color-theme-red);
}

/* upgrade */
.BaseSettings_upgrade_container__uZwZ0 {
  display: flex;
}

.BaseSettings_upgrade_domain_image__shCK4 {
  width: 400px;
  height: 200px;
}

.BaseSettings_upgrade_logo_image__WmHAP {
  width: 280px;
  height: 200px;
}

.BaseSettings_upgrade_content__F2Tar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 50px;
}

.BaseSettings_upgrade_text_large__lNqf7 {
  font-size: 20px;
  font-weight: bold;
}

.BaseSettings_upgrade_btn_container__vxFB7 {
  padding: 20px 0;
}

/* deletion dialog */
.BaseSettings_button_confirm__S\\+b2D {
  font-weight: bold !important;
  width: 100px;
  margin-left: 15px !important;
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
}

.BaseSettings_deletionPopupText__iGU3b {
  padding: 5px;
}

.BaseSettings_deletionPopupButtonContainer__279OI {
  display: flex;
  margin-top: 36px;
  flex-direction: row-reverse;
}

/* PORTAL IMAGE SECTION (moved to bottom) */

.BaseSettings_logo_favicon_container__6EusR {
  padding: 60px 30px 30px 30px;
  width: 55%;
}

.BaseSettings_favicon_container__ey7G\\+ {
  width: 50%;
}

.BaseSettings_portal_image_section__SadGb {
  width: 55%;
  border-top: 1px solid var(--color-theme-bright-gray);
  padding: 30px;
}

.BaseSettings_portal_image_text__BwPf3 {
  padding-bottom: 20px;
}

.BaseSettings_upload_image_container__RUcm0 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.BaseSettings_portal_image_box__ksrPV {
  border: 1px dashed var(--color-border-dashed);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 200px;
  overflow: auto;
  position: relative;
}

.BaseSettings_portal_image_preview__LGKwG {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.BaseSettings_portal_image_delete__47T3o {
  width: 150px;
  display: flex;
  justify-content: flex-end;
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/BaseSettings/BaseSettings.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;EAC5B,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,uCAAuC;EACvC,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;EACzC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,2CAA2C;;AAE3C;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,oDAAoD;EACpD,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  height: calc(100vh - 188px);\n  overflow: auto;\n  color: var(--color-font-10);\n  max-width: 1125px;\n}\n\n.settlement_portal_title {\n  display: flex;\n  align-items: center;\n}\n\n.device_icon {\n  padding-right: 10px;\n}\n\n.arrow_icon {\n  padding: 0 20px;\n  color: var(--color-theme-silver);\n}\n\n.tabs_container {\n  margin-top: 60px;\n  border: 1px solid var(--color-theme-bright-gray);\n}\n\n.tabs_content_container {\n  padding: 60px 30px 30px 30px;\n  border: 1px solid var(--color-theme-bright-gray);\n  border-top: none;\n}\n\n.tabs_content_container_images {\n  border: 1px solid var(--color-theme-bright-gray);\n  border-top: none;\n}\n\n.tab_content_portal_address {\n  width: 70%;\n}\n\n.tab_content_legal_contact {\n  width: 775px;\n}\n\n.example_input_container {\n  display: flex;\n  align-items: center;\n}\n\n.example_input_container p {\n  padding: 0 10px;\n  margin-bottom: 8px;\n}\n\n.input_container {\n  width: 370px !important;\n}\n\n.subdomain_container {\n  padding-bottom: 40px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid var(--color-theme-bright-gray);\n}\n\n.label {\n  padding: 0;\n  margin-bottom: 5px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.label b {\n  font-size: 12px;\n  color: var(--color-theme-red);\n  padding-left: 5px;\n}\n\n.confirm_btn_container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 30px 0;\n}\n\n.confirm_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n}\n\n.description {\n  margin: 0;\n  margin-bottom: 25px;\n  font-size: 16px !important;\n}\n\n.logo_container {\n  width: 50%;\n}\n\n.input_row {\n  display: flex;\n  justify-content: space-between;\n}\n\n/* image upload shared */\n.general_col_images {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.general_image_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.upload_title_container {\n  display: flex;\n  flex-direction: row;\n}\n\n.portal_image_preview_container {\n  width: 50%;\n}\n\n.upload_size {\n  color: var(--color-theme-silver);\n  font-weight: bold !important;\n  font-size: 12px !important;\n}\n\n.dimension_list {\n  padding-left: 10px;\n  font-size: 12px !important;\n}\n\n.upload_size {\n  font-size: 12px !important;\n  font-weight: 500;\n  margin: 0;\n  margin-top: 5px;\n}\n\n.cloud_upload_icon {\n  color: var(--color-theme-blue);\n  cursor: pointer;\n  font-size: 120px;\n}\n\n.cloud_upload_icon_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 14px;\n}\n\n.cloud_upload_icon:hover {\n  color: var(--color-theme-blue);\n}\n\n/* Logo */\n.logo_box {\n  width: 84px;\n  height: 84px;\n  border-radius: 2px;\n  overflow: auto;\n  border: 1px dashed var(--color-border-dashed);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.logo {\n  width: 100%;\n  object-fit: cover;\n}\n\n/* Favicon */\n.favicon_box {\n  border: 1px dashed var(--color-border-dashed);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 84px;\n  height: 84px;\n  border-radius: 2px;\n  overflow: auto;\n  position: relative;\n}\n\n.favicon {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.upload_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.upload_label {\n  border: 1px solid var(--color-theme-silver);\n  border-radius: 15px;\n  background-color: var(--color-theme-silver);\n  padding: 2px 10px;\n  cursor: pointer;\n  margin: 10px;\n  box-shadow: 1px 1px 1px var(--color-theme-darkgray);\n  text-align: center;\n}\n\n.upload_label_disabled {\n  border: 1px solid var(--color-theme-silver);\n  border-radius: 15px;\n  background-color: var(--color-theme-silver);\n  padding: 2px 10px;\n  margin: 10px;\n  text-align: center;\n}\n\n.upload_input {\n  display: none;\n}\n\n.upload_btn {\n  width: 120px;\n  height: 28px;\n  font-weight: bold !important;\n  color: var(--color-theme-10) !important;\n  background-color: var(--color-theme-silver) !important;\n  margin: 0 10px !important;\n}\n\n.image_label {\n  margin-top: 0px;\n  margin-left: 0px;\n}\n\n/* delete icon containers */\n.delete_icon_container_logo {\n  width: 85px;\n  display: flex;\n  justify-content: flex-end;\n  z-index: 10000;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.delete_icon_container_favicon {\n  width: 84px;\n  display: flex;\n  justify-content: flex-end;\n  z-index: 10000;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.delete_icon {\n  color: var(--color-theme-silver);\n  background-color: var(--color-theme-snow);\n  cursor: pointer;\n  padding: 5px;\n}\n\n.delete_icon:hover {\n  color: var(--color-theme-red);\n}\n\n/* upgrade */\n.upgrade_container {\n  display: flex;\n}\n\n.upgrade_domain_image {\n  width: 400px;\n  height: 200px;\n}\n\n.upgrade_logo_image {\n  width: 280px;\n  height: 200px;\n}\n\n.upgrade_content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-left: 50px;\n}\n\n.upgrade_text_large {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.upgrade_btn_container {\n  padding: 20px 0;\n}\n\n/* deletion dialog */\n.button_confirm {\n  font-weight: bold !important;\n  width: 100px;\n  margin-left: 15px !important;\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n}\n\n.deletionPopupText {\n  padding: 5px;\n}\n\n.deletionPopupButtonContainer {\n  display: flex;\n  margin-top: 36px;\n  flex-direction: row-reverse;\n}\n\n/* PORTAL IMAGE SECTION (moved to bottom) */\n\n.logo_favicon_container {\n  padding: 60px 30px 30px 30px;\n  width: 55%;\n}\n\n.favicon_container {\n  width: 50%;\n}\n\n.portal_image_section {\n  width: 55%;\n  border-top: 1px solid var(--color-theme-bright-gray);\n  padding: 30px;\n}\n\n.portal_image_text {\n  padding-bottom: 20px;\n}\n\n.upload_image_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.portal_image_box {\n  border: 1px dashed var(--color-border-dashed);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 150px;\n  height: 200px;\n  overflow: auto;\n  position: relative;\n}\n\n.portal_image_preview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.portal_image_delete {\n  width: 150px;\n  display: flex;\n  justify-content: flex-end;\n  z-index: 100;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `BaseSettings_root__VNr7d`,
	"settlement_portal_title": `BaseSettings_settlement_portal_title__g3OQR`,
	"device_icon": `BaseSettings_device_icon__1az74`,
	"arrow_icon": `BaseSettings_arrow_icon__KIQDF`,
	"tabs_container": `BaseSettings_tabs_container__lrhk+`,
	"tabs_content_container": `BaseSettings_tabs_content_container__aMQWA`,
	"tabs_content_container_images": `BaseSettings_tabs_content_container_images__8cMbo`,
	"tab_content_portal_address": `BaseSettings_tab_content_portal_address__D4g7a`,
	"tab_content_legal_contact": `BaseSettings_tab_content_legal_contact__EyTmB`,
	"example_input_container": `BaseSettings_example_input_container__ap+r9`,
	"input_container": `BaseSettings_input_container__Ahbzb`,
	"subdomain_container": `BaseSettings_subdomain_container__-mUoI`,
	"label": `BaseSettings_label__TPkw9`,
	"confirm_btn_container": `BaseSettings_confirm_btn_container__fGun2`,
	"confirm_btn": `BaseSettings_confirm_btn__7z0Bb`,
	"description": `BaseSettings_description__Aimw7`,
	"logo_container": `BaseSettings_logo_container__IOAlK`,
	"input_row": `BaseSettings_input_row__cjSDe`,
	"general_col_images": `BaseSettings_general_col_images__B05lT`,
	"general_image_container": `BaseSettings_general_image_container__rvHeB`,
	"upload_title_container": `BaseSettings_upload_title_container__9-9Gh`,
	"portal_image_preview_container": `BaseSettings_portal_image_preview_container__jdQS5`,
	"upload_size": `BaseSettings_upload_size__mJ2Ci`,
	"dimension_list": `BaseSettings_dimension_list__QosR0`,
	"cloud_upload_icon": `BaseSettings_cloud_upload_icon__ZMZDQ`,
	"cloud_upload_icon_container": `BaseSettings_cloud_upload_icon_container__3p0TS`,
	"logo_box": `BaseSettings_logo_box__aeKp3`,
	"logo": `BaseSettings_logo__Qxkmx`,
	"favicon_box": `BaseSettings_favicon_box__EduQJ`,
	"favicon": `BaseSettings_favicon__f94U1`,
	"upload_container": `BaseSettings_upload_container__z1+vB`,
	"upload_label": `BaseSettings_upload_label__vRGQl`,
	"upload_label_disabled": `BaseSettings_upload_label_disabled__XptrK`,
	"upload_input": `BaseSettings_upload_input__OTbaR`,
	"upload_btn": `BaseSettings_upload_btn__RLIgX`,
	"image_label": `BaseSettings_image_label__hjSd7`,
	"delete_icon_container_logo": `BaseSettings_delete_icon_container_logo__eS8-n`,
	"delete_icon_container_favicon": `BaseSettings_delete_icon_container_favicon__6dvSG`,
	"delete_icon": `BaseSettings_delete_icon__LvwRG`,
	"upgrade_container": `BaseSettings_upgrade_container__uZwZ0`,
	"upgrade_domain_image": `BaseSettings_upgrade_domain_image__shCK4`,
	"upgrade_logo_image": `BaseSettings_upgrade_logo_image__WmHAP`,
	"upgrade_content": `BaseSettings_upgrade_content__F2Tar`,
	"upgrade_text_large": `BaseSettings_upgrade_text_large__lNqf7`,
	"upgrade_btn_container": `BaseSettings_upgrade_btn_container__vxFB7`,
	"button_confirm": `BaseSettings_button_confirm__S+b2D`,
	"deletionPopupText": `BaseSettings_deletionPopupText__iGU3b`,
	"deletionPopupButtonContainer": `BaseSettings_deletionPopupButtonContainer__279OI`,
	"logo_favicon_container": `BaseSettings_logo_favicon_container__6EusR`,
	"favicon_container": `BaseSettings_favicon_container__ey7G+`,
	"portal_image_section": `BaseSettings_portal_image_section__SadGb`,
	"portal_image_text": `BaseSettings_portal_image_text__BwPf3`,
	"upload_image_container": `BaseSettings_upload_image_container__RUcm0`,
	"portal_image_box": `BaseSettings_portal_image_box__ksrPV`,
	"portal_image_preview": `BaseSettings_portal_image_preview__LGKwG`,
	"portal_image_delete": `BaseSettings_portal_image_delete__47T3o`
};
export default ___CSS_LOADER_EXPORT___;
